import React, { useState } from 'react';
import { Modal } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faEye } from '@fortawesome/free-solid-svg-icons';
import {
  ThumbnailWrapper,
  ThumbnailBox,
  ThumbnailPlaceholder,
  ThumbnailImg,
  ThumbnailEyeBadge,
} from './Styles';

import { OptionThumbnailProps } from './types';

export const OptionThumbnail: React.FC<OptionThumbnailProps> = ({ imageUrl, altText, isDark }) => {
  const [previewOpen, setPreviewOpen] = useState(false);

  return (
    <>
      <ThumbnailWrapper>
        {imageUrl ? (
          <ThumbnailBox $isDark={isDark}>
            <ThumbnailImg src={imageUrl} alt={altText} />
          </ThumbnailBox>
        ) : (
          <ThumbnailPlaceholder $isDark={isDark}>
            <FontAwesomeIcon
              icon={faImage}
              fontSize={20}
              color={isDark ? '#4a5568' : '#c4c4c4'}
            />
          </ThumbnailPlaceholder>
        )}
        {imageUrl && (
          <ThumbnailEyeBadge onClick={(e) => { e.stopPropagation(); setPreviewOpen(true); }}>
            <FontAwesomeIcon icon={faEye} fontSize={9} color="#fff" />
          </ThumbnailEyeBadge>
        )}
      </ThumbnailWrapper>

      {imageUrl && (
        <Modal
          open={previewOpen}
          onCancel={() => setPreviewOpen(false)}
          footer={null}
          centered
          width="auto"
          styles={{ body: { padding: 8, display: 'flex', justifyContent: 'center', alignItems: 'center' } }}
          title={altText}
        >
          <img
            src={imageUrl}
            alt={altText}
            style={{ maxWidth: '80vw', maxHeight: '70vh', objectFit: 'contain', borderRadius: 8 }}
          />
        </Modal>
      )}
    </>
  );
};
